import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class AudioMute extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <rect
            x="7.3"
            y="-0.1"
            transform="matrix(0.7071 0.7071 -0.7071 0.7071 8 -3.3137)"
            width="1.5"
            height={viewPortSize}
          />
          <g>
            <polygon points="5,13.2 5.5,13.7 6.8,13.1 6.8,11.3" />
            <polygon points="2.6,11.2 3.7,10.2 2.5,9.1 2.5,6.9 5.3,4.5 5.3,8.6 6.8,7.1 6.8,2.9 5.5,2.3 1.2,5.9 1,6.5 1,9.5 1.2,10.1" />
          </g>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/AudioMute.js